import React, { useState } from "react";
import {  EmailIcon, LockIcon, EyeIcon, EyeOffIcon, UserAuthIcon } from "../../assets/icons";

const CustomInput = ({
  type = "text",
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  required = false,
  disabled = false,
  className = "",
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isPassword = type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const inputType = isPassword && showPassword ? "text" : type;

  const renderIcon = () => {
    switch (type) {
      case "email":
        return <EmailIcon width="20px" height="20px" />;
      case "password":
        return <LockIcon width="20px" height="20px" />;
      case "text":
      default:
        return <UserAuthIcon width="20px" height="20px" />;
    }
  };

  return (
    <div className={`mb-6 ${className} animate-fadeInUp`}>
      <div className="relative group">
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          onFocus={() => setIsFocused(true)}
          disabled={disabled}
          placeholder={placeholder}
          className={`
            w-full px-5 py-4 pr-12 border-2 rounded-2xl shadow-sm
            focus:outline-none focus:ring-4 focus:ring-red-500/20 focus:border-red-500
            disabled:bg-gray-100 disabled:cursor-not-allowed
            transition-all duration-300 ease-out
            transform hover:scale-[1.01] focus:scale-[1.01]
            ${isPassword ? "pr-20" : ""}
            ${
              error
                ? "border-red-300 focus:border-red-500 focus:ring-red-500/20"
                : "border-gray-200 hover:border-gray-300"
            }
            ${isFocused ? "border-red-500" : ""}
            bg-white/90 backdrop-blur-sm
          `}
          {...props}
        />
                <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
          {renderIcon()}
        </div>

        {isPassword && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 pr-12 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 hover:scale-110"
          >
            {showPassword ? (
              <EyeOffIcon width="20px" height="20px" />
            ) : (
              <EyeIcon width="20px" height="20px" />
            )}
          </button>
        )}
        
        {label && (
          <label
            className={`
            absolute left-5 transition-all duration-300 ease-out pointer-events-none
            ${
              isFocused || value
                ? "text-xs text-red-600 -top-2 bg-white px-2 font-semibold"
                : "text-sm text-gray-500 top-5"
            }
          `}
          >
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
      </div>
      {error && (
        <div className="mt-3 animate-shake">
          <p className="text-sm text-red-600 flex items-center bg-red-50 px-3 py-2 rounded-xl border border-red-200">
            <svg
              className="w-4 h-4 mr-2 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

export default CustomInput;
